const SESSION_ID_KEY = "session_id";
const LOGOUT_FLAG_KEY = "explicit_logout";

export function getSessionId() {
  return sessionStorage.getItem(SESSION_ID_KEY);
}

export function setSessionId(sessionId) {
  sessionStorage.setItem(SESSION_ID_KEY, sessionId);
}

export function clearSessionId() {
  sessionStorage.removeItem(SESSION_ID_KEY);
}

export function setLogoutFlag() {
  sessionStorage.setItem(LOGOUT_FLAG_KEY, "true");
}

export function clearLogoutFlag() {
  sessionStorage.removeItem(LOGOUT_FLAG_KEY);
}

export function hasLogoutFlag() {
  return sessionStorage.getItem(LOGOUT_FLAG_KEY) === "true";
}
const LAST_ROUTE_PATH_KEY = "last_route_path";
const LAST_ROUTE_TITLE_KEY = "last_route_title";

export function setLastRoute(path, title = "") {
  try {
    sessionStorage.setItem(LAST_ROUTE_PATH_KEY, path || "");
    sessionStorage.setItem(LAST_ROUTE_TITLE_KEY, title || "");
  } catch (_) {
    /* ignore storage errors */
  }
}

export function getLastRoute() {
  try {
    const path = sessionStorage.getItem(LAST_ROUTE_PATH_KEY);
    const title = sessionStorage.getItem(LAST_ROUTE_TITLE_KEY) || "";
    return path ? { path, title } : null;
  } catch (_) {
    return null;
  }
}

export function clearLastRoute() {
  try {
    sessionStorage.removeItem(LAST_ROUTE_PATH_KEY);
  } catch (_) {
    /* ignore storage errors */
  }
  try {
    sessionStorage.removeItem(LAST_ROUTE_TITLE_KEY);
  } catch (_) {
    /* ignore storage errors */
  }
}
